import { SHOW_VENDOR_DETAILS } from 'actionTypes/vendorDetailsActionTypes';

export const setVendorDetails = (payload) => ({
  type: SHOW_VENDOR_DETAILS,
  payload,
});
export default {
  setVendorDetails,
};
